import { schema } from "normalizr"
import processTemplateItem from "./item"

export default new schema.Array(processTemplateItem)
